import articleTagsService from '../article-tags/article-tags';
import { localStorage, LocalStorageKeysMapping } from '../local-storage/local-storage';

class ArticleSuggestionsManager {
  static Articles = [];
  SUGGESTIONS_NUM = 3;

  getSuggestionsByArticle(articles, viewedArticle) {
    if (articles.length === 0) {
      return [];
    }

    let suggestions = [];
    
    for (let tag of viewedArticle.tags) {
      const exceptArticles = [...suggestions, viewedArticle];
      const articlesForTag = this._getArticlesByTagExcept(articles, tag, exceptArticles);
      suggestions = suggestions.concat(articlesForTag.slice(0, this.SUGGESTIONS_NUM - suggestions.length));

      if (suggestions.length === this.SUGGESTIONS_NUM) {
        break;
      }
    }

    // if (suggestions.length < this.SUGGESTIONS_NUM) {
    //   suggestions = this._pickRandomSuggestions(articles, suggestions, viewedArticle._id);
    // }

    return suggestions.map((article) => {
      return {
        ...article,
        tags: articleTagsService.getRelevantMyArticleTags(article.tags),
      }
    });
  }

  getSuggestionsByTags(tags) {
    const fictiveArticle = {
      _id: -1,
      tags
    };

    return this.getSuggestionsByArticle(ArticleSuggestionsManager.Articles, fictiveArticle);
  }

  _pickRandomSuggestions(articles, selectedSuggestions, currentArticleId = -1) {
    const finalSuggestions = [...selectedSuggestions]
    let numOFSuggestions = finalSuggestions.length;
    const numOfArticles = articles.length;

    while (numOFSuggestions < this.SUGGESTIONS_NUM) {
      const randIndex = Math.floor(Math.random() * numOfArticles);
      const suggestion = articles[randIndex];

      if (suggestion._id !== currentArticleId && !this._isExistById(finalSuggestions, suggestion._id)) {
        finalSuggestions.push(suggestion);
        numOFSuggestions++;
      }
    }

    return finalSuggestions;
  }

  _getArticlesByTagExcept(articles, tag, suggestions) {
    return articles.filter((article) => {
      if (article.tags.indexOf(tag) === -1) {
        return false;
      }

      if (this._isSeenArticle(article._id)) {
        return false;
      }

      return !this._isExistById(suggestions, article._id);
    });
  }

  _isSeenArticle(articleId) {
    const articleKey = `${LocalStorageKeysMapping.SEEN_MY_ARTICLES}_${articleId}`;
    return localStorage.getItem(articleKey) === 'true';
  }

  _isExistById(articles, id) {
    return this._getArticleById(articles, id) !== undefined;
  }

  _getArticleById(articles, id) {
    return articles.find((article) => {
      return article._id === id;
    });
  }
}

export default ArticleSuggestionsManager;